






























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
class UserInterface5AreYouSure extends Vue {
  @Prop({ default: '' }) title?: string
  @Prop({ default: '' }) iconId?: string
  @Prop({ default: 'Are you sure?' }) areYouSureMessage?: string
  @Prop({ default: '' }) headerCssClass?: any

  @Prop({ default: () => () => false }) yesOptionEvaluationFunction?: any

  @Prop({ default: false }) showDialog?: boolean
  @Prop({ default: '' }) errorMessage?: string

  get showAreYouSureDialog () {
    return this.showDialog
  }

  set showAreYouSureDialog (value: any) {
    this.$emit('show-dialog', value)
  }
}

export default UserInterface5AreYouSure

